import { gql } from "@apollo/client"
import { Company } from "@oysterhr/schema"
import { useQuery } from "@oysterhr/core"

export const USE_PAYMENT_COMPANY_PAYMENT_METHODS = gql`
  query PaymentCompanyPaymentMethods($companyId: ID!) {
    company(companyId: $companyId) {
      id
      paymentCurrencyCode
      paymentMethod {
        ... on PaymentMethodStripeAch {
          id
        }
        ... on PaymentMethodStripeSepa {
          id
        }
        ... on PaymentMethodStripeBacs {
          id
        }
        ... on PaymentMethodStripePad {
          id
        }
      }
    }
  }
`

export const usePaymentCompanyPaymentMethods = (companyId: string) =>
  useQuery<{ company: Company }>(USE_PAYMENT_COMPANY_PAYMENT_METHODS, {
    variables: { companyId },
  })
